














































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'

settings =
  name: "DateStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]

    data: ->
      hasEndDate: @wizard.campaignData.target.date.ends.date?

    computed:
      date: -> @wizard.campaignData.target.date

      startCountOptions: ->
        { period } = @date.starts
        return [1..10] if @currentMemberIsSuperUser()
        return [1..10] if period is 'weeks'
        return [1..10] if period is 'months'
        [1..10]

    mounted: ->
      @initializeCampaignName()

    methods:
      validateStep: ->
        @validateCampaignName()

      validateCampaignName: ->
        { name } = @wizard.campaignData
        unless !!"#{name}".trim().length
          @wizard.setFormError 'campaign_name', 'Choose a name for your campaign'
          @wizard.setModelError 'campaign_name', 'Choose a name for your campaign'

      initializeCampaignName: ->
        @wizard.campaignData.name ||= @deriveName()

      hiChangeStartType: (type) ->
        switch type
          when 'rolling'
            @date.starts.date = null
          when 'static'
            @date.starts.date = dayjs().add(30, 'day').toDate()

      hiChangeStartPeriod: (period) ->
        # switch period
          # when 'weeks'
            # @date.starts.count = 4 if @date.starts.count < 4

      hiChangeEndDateCheckbox: (checked) ->
        if checked
          @date.ends.date = dayjs().add(6, 'month').toDate()
        else
          @date.ends.date = null

      hiChangeEndDateInput: (value) ->
        @hasEndDate = !!value

      deriveName: ->
        Object.values(@wizard.creatives).map((creative) => @deriveNameForCreative(creative[0])).join(' + ')

      deriveNameForCreative: (creative) ->
        switch creative.type
          when 'product_sampling' then @deriveNameForSampling creative
          when 'video_wall' then @deriveNameForVideoWall creative
          when 'onsite_space' then @deriveNameForOnsiteSpace creative
          else @$options.filters.formatSpaceType(creative.type)

      deriveNameForSampling: (creative) ->
        snapshot = creative.activation_snapshot
        isProvidingFood = snapshot.distributing.food
        isProvidingDrink = snapshot.distributing.drink
        isProvidingOtherCpg = snapshot.distributing.other_cpg
        isProvidingPromo = snapshot.distributing.promo

        descriptions = []
        descriptions.push snapshot.food.description || 'Food' if isProvidingFood
        descriptions.push snapshot.drink.description || 'Drink' if isProvidingDrink
        descriptions.push snapshot.other_cpg.description || 'Other CPG' if isProvidingOtherCpg
        descriptions.push snapshot.promo.description || 'Promo' if isProvidingPromo

        addonNames = Object.keys(snapshot.supplier_provisions).map((addonType) =>
          name = @$options.filters.formatTitle(addonType)
          addon = snapshot.supplier_provisions[addonType]

          return unless addon
          return name if typeof addon is 'boolean'
          return name if typeof addon is 'object' and addon.required
        ).filter((addon) -> addon)

        [...descriptions, ...addonNames].join(' + ')

      deriveNameForVideoWall: (creative) ->
        @$options.filters.formatSpaceType(creative.type)

      deriveNameForOnsiteSpace: (creative) ->
        @$options.filters.formatSpaceType(creative.activation_snapshot.size)

      isStaticDateDisabled: (date) ->
        nextAvailableDate = dayjs() if @currentMemberIsSuperUser()
        nextAvailableDate ||= dayjs().add(29, 'day')
        !dayjs(date).isAfter(nextAvailableDate, 'day')

export default VueOptions.vue settings
